document.addEventListener('DOMContentLoaded', async () => {
    const canvas = document.getElementById("GrossYieldGauge");
    if (!canvas) return;

    // Load Chart.js only on pages that actually render the gauge
    const { Chart, registerables } = await import('chart.js');
    Chart.register(...registerables);

    const ctx = canvas.getContext("2d");

    // Daten aus den data-Attributen auslesen
    const grossYield = parseFloat(JSON.parse(canvas.dataset.value));
    const maxYield = parseFloat(JSON.parse(canvas.dataset.max));
    const yieldColor = JSON.parse(canvas.dataset.color);

    // Erzeuge zwei Segmente: eines für den Wert, eines für den Rest
    const gaugeData = [grossYield, Math.max(0, maxYield - grossYield)];

    new Chart(ctx, {
        type: 'doughnut',
        data: {
            labels: ['Yield', 'Remaining'],
            datasets: [{
                data: gaugeData,
                backgroundColor: [
                    yieldColor,
                    '#e0e0e0'
                ],
                borderWidth: 0
            }]
        },
        options: {
            rotation: -Math.PI,       // Startet links (halber Kreis)
            circumference: Math.PI,     // Zeigt einen halben Kreis
            cutoutPercentage: 70,       // Dicke des Rings
            responsive: true,
            maintainAspectRatio: false,
            legend: { display: false },
            tooltips: { enabled: false },
            animation: {
                animateRotate: true,
                animateScale: true
            }
        }
    });
});
